module.exports = __webpack_public_path__ + "static/img/95073C_1_2_C_20220324_fit.04a003c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95073C_1_2_C_20220324_fit.png
// module id = UWLP
// module chunks = 0